export default class StaffModel {
    public static Create(obj: StaffModel) {
        return Object.assign(new StaffModel(), obj)
    }
    id: number = 0
    name: string = ''
    email: string = ''
    phone: string = ''
}
